module.exports = __webpack_public_path__ + "static/media/image 24.f9a1be88.png";